// src/redux/examSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_exam,
  add_exam,
  update_exam,
  delete_exam,
  get_examlist
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  exam: [],
  examlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
    examtype: "",
    school_class: "",
    section: "",
    mode: "",
    center: "",
    description: "",
  },
};

export const fetchexamlist = createAsyncThunk(
    'examt/fetchexamlist',
    async ({school_id,session,school_class,section,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_examlist(school_id,session,school_class,section,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

// Async Thunks for API Calls
export const fetchexam = createAsyncThunk(
  "exam/fetchexam",
  async ({ page, page_size,school_id,search, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_exam(page, page_size,school_id,search,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createexam = createAsyncThunk(
  "exam/createexam",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_exam(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexam = createAsyncThunk(
  "exam/updateexam",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_exam(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexam = createAsyncThunk(
  "exam/deleteexam",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_exam({ ids },school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// exam Slice
const examSlice = createSlice({
  name: 'exams',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
         name:"",
            examtype: "",
    school_class: "",
    section: "",
    mode: "",
    center: "",
    description: "",
      };
    },
    setexam(state, action) {
      state.exam = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder   
     .addCase(fetchexamlist.fulfilled, (state, action) => {
        state.loading = false;
        state.examlist = action.payload;
        
      })
      .addCase(fetchexamlist.rejected, (state, action) => {
        state.loading = false;
        state.examlist = [];
      })
  
       // Fetch exam
       .addCase(fetchexam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexam.fulfilled, (state, action) => {
        state.loading = false;
        state.exam = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchexam.rejected, (state, action) => {
        state.loading = false;
        state.exam = [];
        state.error = action.payload;
      })

      // Add exam
      .addCase(createexam.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexam.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexam.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update exam
      .addCase(updateexam.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexam.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexam.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete exam
      .addCase(deleteexam.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexam.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexam.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setexam,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = examSlice.actions;
export default examSlice.reducer;


